export const RENTAL_DATES_OPTIONS = {
	SPECIFIC_DAYS: 'specificDates',
	LEAD_TIMES: 'withinDays',
	DAY_WEEK: 'dayWeek',
	FULL_MONTH: 'nextFullMonth',
	DAY_SELECTED: 'daysSelected',
	WEEK_SELECTED: 'weekSelected',
	OPTION_SELECTED: 'optionSelected',
	OPTION_SELECTED_FORM: 'rentalDateOption'
}

export const REPORT_ACTIONS = {
	MULTI_REPORT: 'multiReport',
	MULTI_EXPORT: 'multiExport',
	GENERATE: 'generate',
	EXPORT: 'export'
}

export const MULTIPLE_OPTIONS = {
	SITES: 'sites',
	DATES: 'specificDates',
	EMAILS: 'notification_email_cc',
	RUN_EXECUTIONS: 'runExecutions',
	STOP_EXECUTIONS: 'stopExecutions',
	FREQUENCY: 'frequency',
	EXECUTION_DATES: 'executionDates'
}

export const NUM_SEARCHES_FIELDS = [
	"sites",
	"specificDates",
	"withinDays",
	"nextFullMonth",
	"daysSelected",
	"weekSelected",
	"oneWayRoutes",
	"idOfficeGroup",
	"idOfficePickup",
	"lengthOfRental",
	"timeFrom",
	"daysMonitorized",
	"checkinWeekdayFilter",
	"terminationDate",
	"customConfigData",
	"oneWayRoutes"
]

export const REPORT_STATUS = {
	READY: 'ready',
	RUNNING: 'running',
	GENERATING: 'generating',
	STOPPED: 'stopped'
}

export const INFO_MODAL_TABS = {
	DETAILS: 'details',
	HISTORY: 'history'
}

export const DAYS = ["Mondays", "Tuesdays", "Wednesdays", "Thursdays", "Fridays", "Saturdays", "Sundays"]

export const MULTIPLE_MODAL_LOADING = { ADD: 'add', REMOVE: 'remove', UPDATE: 'update', UPDATE_EXECUTION_DATES: 'update-execution-dates' }

export const REPORT_TYPE_TABS = {
	REPORTS: 1,
	RATING: 2,
	ONE_WAYS: 3
}

//report types that only work with part of the user sites
export const REPORT_TYPE_SITE_FILTERS = {
	[REPORT_TYPE_TABS.RATING]: { getDirectSites: false }
}
